/* unplugin-vue-components disabled */import { render } from "./PostCard.vue?vue&type=template&id=26433be6&scoped=true"
import script from "./PostCard.vue?vue&type=script&lang=js"
export * from "./PostCard.vue?vue&type=script&lang=js"

import "./PostCard.vue?vue&type=style&index=0&id=26433be6&lang=css"
import "./PostCard.vue?vue&type=style&index=1&id=26433be6&scoped=true&lang=css"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26433be6"]])

export default __exports__